import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { TopDecorColor } from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  color: white;
  width: calc(33.33% - 14px);
  min-width: 220px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;

  &:hover {
    border-color: rgba(163, 27, 27, 0.55);
    box-shadow: 0 6px 22px rgba(0, 0, 0, 0.35);
    transform: translateY(-4px);
  }
`;

const ImageBox = styled.div`
  width: 100%;
  height: 150px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
    transition: transform 0.3s ease;
  }

  ${Container}:hover & img {
    transform: scale(1.05);
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 12px 12px;
  gap: 3px;

  .arena-name {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;
    margin: 0;
  }

  .arena-location {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.4);
    margin: 0;
    text-align: center;
  }
`;

interface Arena {
  id: number;
  name: string;
  img_path: string;
  state: string;
  city: string;
}

const SingleCardArena: FC<{ arena: Arena }> = ({ arena }) => {
  const navigate = useNavigate();

  return (
    <Container onClick={() => navigate('/arenas/' + arena.id)}>
      <TopDecorColor />
      <ImageBox>
        <img
          src={process.env.REACT_APP_STORAGE_URL + arena.img_path}
          alt={arena.name}
        />
      </ImageBox>
      <Info>
        <p className="arena-name">{arena.name}</p>
        <p className="arena-location">{arena.state}, {arena.city}</p>
      </Info>
    </Container>
  );
};

export default SingleCardArena;
